import Client from "../Pages/Client";
import ClientPortfolio from "../Pages/ClientPortfolio";
import Home from "../Pages/Dashboard";
import EnergyBills from "../Pages/EnergyBills";
import EnergyTracker from "../Pages/EnergyTracker";
import Portfolio from "../Pages/Portfolio";
import ViewBill from "../Pages/ViewBill";
import Property from "../Pages/Property";
import MeterReport from "../Pages/MeterReport";
import GroupMeterReport from "../Pages/GroupMeterReport";

export const routes = [
    { path: `${process.env.PUBLIC_URL}/dashboard`, element: <Home /> },
    { path: `${process.env.PUBLIC_URL}/portfolio`, element: <Portfolio />},
    { path: `${process.env.PUBLIC_URL}/client/portfolio`, element: <ClientPortfolio />},
    { path: `${process.env.PUBLIC_URL}/client/property/:propertyId`, element: <Property />},
    { path: `${process.env.PUBLIC_URL}/clients/:clientId`, element: <Client />},
    { path: `${process.env.PUBLIC_URL}/apps/bills`, element: <EnergyBills />},
    { path: `${process.env.PUBLIC_URL}/apps/energy-tracker`, element: <EnergyTracker />},
    { path: `${process.env.PUBLIC_URL}/bills/:billId`, element: <ViewBill />},
    { path: `${process.env.PUBLIC_URL}/meter-reports`, element: <MeterReport />},
    { path: `${process.env.PUBLIC_URL}/group-meter-reports`, element: <GroupMeterReport />},
]